module.exports = __webpack_public_path__ + "img/mail.2e31e964.svg";